module.exports = __webpack_public_path__ + "static/media/privacy-en.0bf5c884.md";